import { Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../../components/CustomButton";
import CustomCard from "../../../../components/CustomCard/CustomCard";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import {
  getClinicInpatients,
  updateAppointmentStatusById,
  updateHospitalizationStatus,
} from "../../../../redux/reducers/clinicSlice";
import { storeInpatientScreenDetails } from "../../../../redux/reducers/mixedSlice";
import { patchMandateSession } from "../../../../util/mandateSessionStorage";
import BookAnAppointment from "../../../CommonScreens/BookAppointmentment/BookAnAppointment";

const initSearchValues = { Recovery: "", Billing: "", Completed: "" };

const Hospitalization = ({ selectedVet }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [followUpModVsble, setFollowUpModVsble] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [disCofrmModVsble, setDisCofrmModVsble] = useState(false);
  const [searchValues, setSearchValues] = useState(initSearchValues);
  const { inpatients, details: clinicDetails } = useSelector(
    (state) => state?.clinic,
  );

  useEffect(() => {
    onApiCall();
  }, [selectedVet]);

  const onApiCall = () => {
    let url = "?type=all";
    if (selectedVet !== "All")
      url = `?type=doctor&doctorId=${selectedVet?.id ?? selectedVet}`;
    dispatch(getClinicInpatients(url)).then((res) => {
      if (res?.payload) {
        if (selectedVet === "All") {
          patchMandateSession({
            inpatients: res?.payload?.data ?? [],
          });
        }
      }
    });
    dispatch(storeInpatientScreenDetails({ selectedVet }));
  };

  const filterAppointmentsByVet = (typ) => {
    const reqTypes =
      typ === "recovery"
        ? ["recovery", "insurgery", "scheduled", "consultation", "inprogress"]
        : [typ];
    return inpatients?.data?.filter(
      (li) =>
        // li?.inpatient &&
        li?.hospitalization && reqTypes.includes(li?.appointmentStatus),
    );
  };

  const onUpdateStatus = (li, actType) => {
    if (!li?.appointmentId) return;
    if (actType === "Send To Surgery") {
      dispatch(
        updateHospitalizationStatus({
          patientId: li?.patientId,
          status: false,
        }),
      ).then((res) => {
        if (res?.payload) {
          dispatch(
            updateAppointmentStatusById({
              appointmentId: li?.appointmentId,
              status: "scheduled",
              successMsg: "Status updated successfully!",
            }),
          ).then((res2) => {
            if (res2?.payload) {
              onApiCall();
            }
          });
          // onApiCall();
        }
      });
      return;
    }
    let status = "finalize";
    if (actType === "Discharge") {
      setSelectedItem(li);
      setDisCofrmModVsble(true);
      return;
    }
    // status = "finalize";
    if (actType === "Check-out") status = "completed";
    dispatch(
      updateAppointmentStatusById({
        appointmentId: li?.appointmentId,
        status,
        successMsg: "Status updated successfully!",
      }),
    ).then((res) => {
      if (res?.payload) {
        // if (status === "completed" && li?.patientId) {
        //   dispatch(dischargePatientId(li?.patientId));
        // }
        onApiCall();
      }
    });
  };

  const onFollowUp = (li) => {
    setSelectedItem(li);
    setFollowUpModVsble(true);
  };

  const navigatePetDetailsScreen = (appointment) => {
    // if (appointment?.appointmentId) {
    //   dispatch(getPetsCompliantSummary(appointment?.appointmentId));
    // } else if (appointment?.petId) {
    //   dispatch(getPetDetailsById(appointment?.petId));
    // }
    navigate(`/clinic-pet-details`, {
      state: { appointment: { appoinment: appointment } },
    });
  };

  const handleChangeCardSearchValue = (value, type) => {
    const reqObj = { ...searchValues, [type]: value };
    setSearchValues(reqObj);
  };

  const renderSection = (
    title,
    data,
    colorClass,
    sectionType,
    checkIn,
    threedots,
  ) => {
    const filteredData = data?.filter((li) => {
      const search = searchValues?.[sectionType]?.toLowerCase();
      if (!search) return true;
      return (
        li?.petName?.toLowerCase()?.includes(search) ||
        li?.userName?.toLowerCase()?.includes(search) ||
        li?.doctorName?.toLowerCase()?.includes(search)
      );
    });

    return (
      <div
        className={`${
          sectionType === "Recovery" ? "w60Per" : "w20Per"
        } borderRight`}
      >
        <div className="flex-row">
          <div className="p10MinWid99Per ">
            <Typography
              className={`card-head-${colorClass}-color card-head-border-bottom-${colorClass} font-bold fs20`}
            >
              {title} ({data?.length ?? 0})
            </Typography>
            <CustomCard
              list={filteredData ?? []}
              inpatient
              hospitalization
              sectionType={sectionType}
              onClickResch={
                (li) => {}
                // createModalOpen(li, false)
              }
              onReassign={
                (li) => {}
                // createModalOpen(li, true)
              }
              handleAction={(li, actType) => onUpdateStatus(li, actType)}
              handleCancel={
                (li) => {}
                // handleDelModClose(li)
              }
              handleCompleted={
                (li) => {}
                // handleCompleted(li)
              }
              onFollowUp={(li) => onFollowUp(li)}
              onClick={(li) => navigatePetDetailsScreen(li)}
              checkIn={checkIn}
              threedots={threedots}
              handleConsult={
                (li) => {}
                //  handleConsult(li)
              }
              handleCheckout={
                (li) => {}
                // handleCheckout(li)
              }
              handleAdmit={
                (itm) => {}
                //  handleAdmit(itm)
              }
              searchValue={searchValues[sectionType]}
              onChangeSearchValue={handleChangeCardSearchValue}
              clinicDetails={{ billingMode: clinicDetails?.billingMode }}
            />
          </div>
        </div>
      </div>
    );
  };

  const onCloseFollowUpMod = () => {
    setFollowUpModVsble(false);
    setSelectedItem(null);
  };

  const onCloseDischargeMod = () => {
    setDisCofrmModVsble(false);
    setSelectedItem(null);
  };

  const onConfrimDischarge = () => {
    dispatch(
      updateAppointmentStatusById({
        appointmentId: selectedItem?.appointmentId,
        status: "finalize",
        successMsg: "Status updated successfully!",
      }),
    ).then((res) => {
      if (res?.payload) {
        onCloseDischargeMod();
        onApiCall();
      }
    });
  };

  return (
    <>
      <div className="flex-center mt20">
        {renderSection(
          "Treatment & Recovery",
          filterAppointmentsByVet("recovery"),
          "orange",
          "Recovery",
          true,
          true,
        )}
        {renderSection(
          "Billing & Discharge",
          filterAppointmentsByVet("finalize"),
          "yellow",
          "Billing",
          true,
          true,
        )}
        {renderSection(
          "Completed",
          filterAppointmentsByVet("completed"),
          "paleGreen",
          "Completed",
          true,
          true,
        )}
      </div>
      {followUpModVsble ? (
        <BookAnAppointment
          modalVisible={followUpModVsble}
          setBookModVisible={onCloseFollowUpMod}
          selectedPet={{
            petId: selectedItem?.petId,
            petName: selectedItem?.petName,
            petImage: selectedItem?.petImage,
            gender: selectedItem?.gender,
            breed: selectedItem?.breed,
            dob: selectedItem?.dob,
            userName: selectedItem?.userName,
            color: selectedItem?.color,
            weight: selectedItem?.weight,
            userMobile: selectedItem?.userMobile,
            mobile: selectedItem?.mobile,
          }}
          prevAppointmentId={selectedItem?.appointmentId}
        />
      ) : null}
      <CustomModal
        open={disCofrmModVsble}
        onClose={onCloseDischargeMod}
        header="Discharge Pet"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to Discharge the patient?
        </Typography>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                onClick={onConfrimDischarge}
                smallBtn
              />
            </div>
            <div className="ml10">
              <CustomButton text="No" smallBtn onClick={onCloseDischargeMod} />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </>
  );
};

export default Hospitalization;
